import React from 'react';
import { Colors, Images } from 'utils';
import { MinLoader } from '../loader';

export const EditWithIcon = ({ handleClick, styles, load, icon, type, disabled, id, innerText }) => {
    return (
        <button
            id={id ? id : 'edit-btn'}
            disabled={disabled}
            type={type}
            style={{ ...styles }}
            className="edit-btn-box"
            onClick={handleClick}
        >
            {load ? (
                <div>
                    <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
                </div>
            ) : (
                <div className="flex-align-center" style={{ gap: 8 }}>
                    <img src={icon ? icon : Images.edit} alt="" />
                    {innerText && <p>{innerText}</p>}
                </div>
            )}
        </button>
    );
};
